import { useLocation } from "react-router-dom";

// /embed/ pages run inside the mobile apps' dashboard webview, so callers hide links that would lead out of it or UI that isn't relevant
export const useIsEmbedded = () => useLocation().pathname.startsWith("/embed/");
